export default "/images/4c8ae2ad3268213ebe0765809bad6bd6.avif";